import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function VALoanPage() {
  return (
    <LoanProgramTemplate
      title="VA Loans"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907462/VA_rw8hjs.png"
      descriptionBold="VA loans"
      description="offer a significant financing benefit for eligible service members, Veterans, and surviving spouses. These loans are backed by the Department of Veterans Affairs to make homeownership more accessible."
      whyBuyersConsider="VA loans may reduce upfront and monthly costs through features like no required down payment and no mortgage insurance, helping eligible borrowers stretch their budget further."
      eligibilityItems={[
        'Must meet VA service criteria, verified through a Certificate of Eligibility',
        'Standard credit and income requirements apply',
        'Property must be used as a primary residence',
        'Certain occupancy and VA documentation rules apply',
      ]}
      benefitsItems={[
        'No down payment for most eligible borrowers',
        'No private mortgage insurance requirement',
        'Competitive interest rate structure',
        'Limits on certain fees to help reduce upfront costs',
      ]}
    />
  );
}
